import { styled } from '@mui/material/styles';
import { InputLabel } from 'shared/mui/Labels/InputLabel/InputLabel';
import { Select } from 'shared/mui/Select/Select';

export const StyledSelect = styled(Select)(({ theme }) => ({
  marginBottom: '24px',
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px dotted ${theme.palette.action.disabled}`,
  },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.text.disabled,
  background: theme.palette.background.default,
  padding: '0 4px',
  left: '-4px',
}));
